// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import issueResolutionEntity from './entities/issue-resolution.json';
import issueResolutionMenu from '../pages/issue-resolution/menu.json';
import issueResolutionFullForm from '../pages/issue-resolution/forms/full.json';
import issueResolutionContextForm from '../pages/issue-resolution/forms/context.json';
import issueResolutionMiniForm from '../pages/issue-resolution/forms/mini.json';
import issueResolutionLookupForm from '../pages/issue-resolution/forms/lookup.json';
import issueResolutionTableView from '../pages/issue-resolution/views/table.json';
import issueResolutionCardsView from '../pages/issue-resolution/views/cards.json';
import issueResolutionDashboardView from '../pages/issue-resolution/views/dashboard.json';

/** Тип запису «Вирішення проблеми» зі сторінками пакета: меню, форми та подання з pages/issue-resolution/. */
export const issueResolutionDefinition: IRecordTypeDefinition = {
  ...issueResolutionEntity,
  views: assembleViewSet({
      table: issueResolutionTableView,
      cards: issueResolutionCardsView,
      dashboard: issueResolutionDashboardView,
  }),
  form: issueResolutionFullForm,
  forms: { full: issueResolutionFullForm, context: issueResolutionContextForm, mini: issueResolutionMiniForm, lookup: issueResolutionLookupForm },
  menu: issueResolutionMenu,
} as IRecordTypeDefinition;
